import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useListingContext } from '@/context/listing';
import useOnClickOutside from '@/hooks/useOnClickOutside';

const SortMenu = () => {
  const ref = useRef();
  const [isSortOpen, openSort] = useState(false);
  const { t } = useTranslation();

  useOnClickOutside(ref, e => {
    // Click on button prevents close and open loop
    const elementsToIgnore = [
      'del-plp-filters__sort-button',
      'del-plp-filters__sort-button-icon',
    ];

    if (
      ![...e.target.classList].some(elClass =>
        elementsToIgnore.includes(elClass),
      )
    ) {
      openSort(false);
    }
  });

  const toggleSort = () => {
    openSort(!isSortOpen);
  };

  const [{ sorts }, { setQuerySort }] = useListingContext();

  const sortMenuItems = sorts.map(sortItem => {
    const { name, code, selected } = sortItem;
    return (
      <button
        key={`${code}-wrapper`}
        type='button'
        className={`del-button del-plp-filters__sort-menu-row js-sortby-filter ${
          selected ? 'del-plp-filters__sort-menu-row--active' : ''
        }`}
        data-sort-label={code}
        onClick={() => setQuerySort(code)}
      >
        <i
          key={`${code}-icon`}
          className={`del-icon ${
            selected ? 'icon-ok-black' : ''
          } del-plp-filters__sort-menu-row-icon`}
        />{' '}
        {name}
      </button>
    );
  });

  const selectedSort = sorts.find(sort => sort.selected);

  return (
    <div ref={ref} className='del-plp-filters__sort-wrapper'>
      <button
        type='button'
        className='del-button del-plp-filters__sort-button del-plp-filters__sort-button--down'
        onClick={toggleSort}
      >
        <span className='del-plp-filters__sort-mobile-label'>
          {t('listing:listing.sort.cta.label')}
        </span>
        <span className='del-plp-filters__sort-desktop-label'>
          {t('listing:listing.sort.desktop.cta.label')}{' '}
          <span className='del-plp-filters__sort-desktop-label-selected'>
            {selectedSort ? selectedSort.name : ''}
          </span>
        </span>
        <i
          className={`del-plp-filters__sort-button-icon del-icon ${
            isSortOpen ? 'icon-select-up' : 'icon-select-down'
          }`}
        />
      </button>
      {isSortOpen ? (
        <div className='del-plp-filters__sort-menu'>
          <div className='del-plp-filters__sort-menu-close-row'>
            <button
              type='button'
              className='del-button del-plp-filters__sort-menu-close'
              onClick={toggleSort}
            >
              <i className='del-icon icon-menu-close del-plp-filters__sort-menu-close-icon' />
            </button>
          </div>
          {sortMenuItems}
          <div className='del-plp-filters__sort-menu-shadow' />
        </div>
      ) : null}
    </div>
  );
};

export default SortMenu;
